import * as React from "react";

const PbhRequestOrderView = props => {
  return <div>Coming Soon...</div>;
};

export default PbhRequestOrderView;
